
<section class="failure">
  <p class="title">{{ "Failure" | translate }}</p>
  <p class="failure-text">
    {{ "Failure.Text" | translate }}&nbsp;<a href="/contact-info">{{
      "Failure.Text.Two" | translate
    }}</a
    >&nbsp;{{ "Failure.Text.Three" | translate }}
  </p>

  <p class="sorry-text">{{ "Failure.Sorry.Text" | translate }}</p>
</section>
